<template>
  <div v-if="clinicalUserEditing && clinicalUserEditing.id">
    <div>
      <span>{{ $t('lastLogin') }}</span>
      <span>{{ lastLoginDate }}</span>
    </div>
    <div v-if="clinicalUserEditing.account_information.last_activity">
      <span>{{ $t('latest_activity_codes.value_' + clinicalUserEditing.account_information.last_activity.code) }}</span>
      <span>{{ lastActivityDate }}</span>
    </div>
  </div>
</template>

<script>
import { Helpers } from '@/mixins/Helpers'
import { mapGetters } from 'vuex'
import { LastLoginAndLastActivity } from '@/mixins/LastLoginAndLastActivity'

export default {
  name: 'SettingsClinicalUsersBottomPanelLeft',
  mixins: [Helpers, LastLoginAndLastActivity],
  computed: {
    ...mapGetters({
      clinicalUserEditing: 'getSettingEditingInForm'
    })
  }
}
</script>
